import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Card extends React.Component {
  constructor(props) {
    super(props);

    // Define inline styles for card background color
    this.styles = { backgroundColor: props.data.color || '#000' };
  }

  render() {
    const { title, icon, details } = this.props.data;

    return (
      <div className="service-card-body" style={this.styles}>
        <div className="service-card-icon-wrapper service-card-section">
          <span className="service-card-icon">
            <FontAwesomeIcon icon={icon} size="4x" />
          </span>
        </div>
        <div className="service-card-text-wrapper service-card-section">
          <div className="service-card-title"><span>{title}</span></div>
          {/* Hover effect text */}
          <div className="service-card-hover-text">
            <span>{details}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Card;
